module.exports = __webpack_public_path__ + "img/difficultyLevel_0.f266c148.svg";